export const formatTime12Hour = (time) => {
    if (!time) return "";

    const [hours, minutes] = time.split(":");

    return new Date(
        2000,
        0,
        1,
        Number(hours),
        Number(minutes)
    ).toLocaleTimeString([], {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    });
};

export const convertTime = (time) => {
    if (!time) return "—";

    const [hours = 0, minutes = 0, seconds = 0] = time
        .split(":")
        .map(Number);

    const date = new Date();
    date.setHours(hours, minutes, seconds);

    return date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    });
};

export const timeToSeconds = (time) => {
    const [h, m, s] = time.split(":").map(Number);
    return h * 3600 + m * 60 + s;
};

export const formatTimeToWords = (time) => {
    if (!time) return "—";

    const [hours, minutes, seconds] = time.split(":").map(Number);

    const parts = [];

    if (hours > 0) parts.push(`${hours} hr${hours > 1 ? "s" : ""}`);
    if (minutes > 0) parts.push(`${minutes} min`);
    if (seconds > 0) parts.push(`${seconds} sec`);

    return parts.join(" ");
};